import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

const API_ACCOUNTS_URL = `${environment.apiUrl}/Accounts`;

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    constructor(private http: HttpClient) {}

    getMyCv(): Observable<any> {
        return this.http.get(API_ACCOUNTS_URL + '/GetMyCv');
    }

    getCvByUserId(input: any): Observable<any> {
        return this.http.post(API_ACCOUNTS_URL + '/GetCvByUserId', input);
    }

    updatePassword(input: any) {
        return this.http.post(API_ACCOUNTS_URL + '/UpdatePassword', input);
    }

    requestPassword(input: any) {
        return this.http.post(API_ACCOUNTS_URL + '/RequestPassword', input);
    }

    resetPassword(input: any) {
        return this.http.post(API_ACCOUNTS_URL + '/ResetPassword', input);
    }

    updateAccountPhoto(input: any): Observable<any> {
        return this.http.post(API_ACCOUNTS_URL + '/UpdateAccountPhoto', input);
    }

    updateAccountDetail(input: any): Observable<any> {
        return this.http.post(API_ACCOUNTS_URL + '/UpdateAccountDetail', input);
    }

    updateAccountDetailFromMernis(): Observable<any> {
        return this.http.post(API_ACCOUNTS_URL + '/UpdateAccountDetailFromMernis', null);
    }
}
